import React from 'react';
import { useTranslation } from 'react-i18next';

const FundOptions = ({ funds, selectedFund, setSelectedFund }) => {
  const { t, i18n } = useTranslation();
  if (funds.length <= 1) return null;

  return (
    <>
      <h3 className="text-xl font-semibold mb-3 header" style={{ color: 'var(--primary-color)' }}>{t('autoAjr.fundOptions')}</h3>
      <div className="mb-6">
          <div className="panels-section">
            {funds.map((fund) => (
              <div
                className={`panel ${selectedFund === fund.slug ? 'selected' : ''}`}
                onClick={() => setSelectedFund(fund.slug)}
              >
                <h3>{fund.name}</h3>
                <p>{fund.description[i18n.resolvedLanguage]}</p>
              </div>
            ))}
          </div>
      </div>
    </>
  );
};

export default FundOptions;